import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@pinpoint/design-kit';
import DefaultTheme from 'src/styles/DefaultTheme';

const StyledButton = styled(Button)`
  :active {
    background-color: ${({ disabled }) => (!disabled ? DefaultTheme.colors.grey500 : '')};
  }
`;

function SecondaryButton({ children, ...userProps }) {
  return (
    <StyledButton bg="grey300" hoverBg="grey800" m={{ r: '0.5rem' }} p={{ x: '0.75rem' }} h="1.875rem" {...userProps}>
      {children}
    </StyledButton>
  );
}

SecondaryButton.defaultProps = {
  children: null,
};

SecondaryButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default SecondaryButton;
